import {mapActions, mapGetters, mapMutations} from 'vuex';
import chatComponent from '@/components/features/chat-component/index.vue';
import retakingHistory from '@/components/features/graduate-work-retaking-history/index.vue';
import { seo } from '@/mixins/seo';

export default {
    name: 'graduate-work-check',
    mixins: [seo],
    components: {
        chatComponent,
        retakingHistory
    },
    created() {
        this.changeHeader({
            show: true,
            title: '',
            parentRoute: {name: 'courses-main', params: {item: this.$route.params.item}}
        })

        this.fetchItem({
            courseSlug: this.$route.params.item
        }).then(() => {
            this.changeHeader({
                show: true,
                title: '',
                parentRoute: {name: 'courses-main', params: {item: this.$route.params.item}}
            })

            this.seo.title = this.currentItem.name + ' - ' + this.course.name;
            this.$emit('updateHead')
        })
    },
    mounted() {
        // land at the top after navigation/reload, not stuck at the page bottom
        this.$nextTick(() => {
            const app = document.querySelector('.app');
            if (app) app.scrollTop = 0;
            window.scrollTo(0, 0);
        });
    },
    computed: {
        ...mapGetters({
            isLoading: 'coursesGraduateWork/isLoading',
            currentItem: 'coursesGraduateWork/currentItem',
            course: 'courses/currentItem',
        }),
    },
    methods: {
        ...mapActions({
            fetchItem: 'coursesGraduateWork/GET_LIST_ITEM'
        }),
        ...mapMutations({
            changeHeader: 'coursesGraduateWork/CHANGE_HEADER',
            setItem: 'coursesGraduateWork/SET_ITEM'
        }),
        declensionWord(count, type) {
            let titles = [this.$t(`${type}1`), this.$t(`${type}2`), this.$t(`${type}3`)];
            let cases = [2, 0, 1, 1, 1, 2];
            return titles[(count % 100 > 4 && count % 100 < 20) ? 2 : cases[(count % 10 < 5) ? count % 10 : 5]];
        },
        navigateTo(route) {
            try {
                this.$router.push({
                    name: route,
                    params: {graduateWorkId: this.$route.params.graduateWorkId, item: this.$route.params.item}
                })
            } catch (e) {
                console.log(e);
            }
        }
    },
    destroyed() {
        this.setItem(null);
        this.changeHeader({
            show: false,
            title: '',
            parentRoute: ''
        })
    }
}
